export default __webpack_public_path__ + "static/media/discord.667df059.png";